module.exports = __webpack_public_path__ + "img/item-info-icon1.6befbcd9.svg";